
function Menu() {
    /// <summary>
    /// This object does the complete handling of the Widget.Master.Menu.vb. <br/>
    /// It allows to add/delete favorites ....
    /// <br/>
    /// It is inherited from scripts/visualcore/widgets/Master/Master.js
    /// Author: ARF<br />
    /// Date: 28.9.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 7.6.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - integrated isPreview in init()                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 30.9.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
Menu.prototype = new Master();

Menu.prototype.init = function () {
    /// <summary>
    /// First, this function loads existing user options and sets them. <br/>
    /// Then, it inits all click and filter handlers. 
    /// </summary>
    var me = this;
    try {
     
        if (me.error) {
            return false;
        }
      
        me.filterFav = false;
        //do not filter favorites for the preview menu
        if (me.isPreview) {
            me.initList();
            me.filter();
        } else {
            me.userOptions = new vcUserOptions("menu-favorites", "menu");
            me.initUserOptions();
        }
      
        ////init the click handler to set favorites
        me.visual.find('.list').off('click', '.fav').on('click', '.fav', function (e) {
            me.toggleFavorites($(this)); e.stopPropagation();
        });
       
        ////init the filter events
        me.visual.find("#txtFilter").off('keyup').on('keyup', function (e) {
            me.filter(); e.stopPropagation();
        });
        me.visual.find("#txtFilter").off('change').on('change', function (e) {
            me.filter(); e.stopPropagation();
        });


        return true;
    } catch (ex) { me.writeError('initClickHandler', ex); return false;}
};



Menu.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes the css-class 'found' for filtering menu entries.<br/>
    /// When an entry with a filter expression gets found the 'found' class gets added. <br/>
    /// At the end, basically all 'found' classes get shown - the favorites state gets considered as well.<br/>
    /// </summary>
    var me = this;
    var filter;
    var i;
    try {
        
        me.visual.find('.menu-box').show();
        me.visual.find(".menu-box-content li").removeClass("found").show();

        //get a list of filter expressions
        if (me.visual.find("#txtFilter").val().trim().length > 0) {
            filter = me.visual.find("#txtFilter").val().trim();
            filter = filter.split(" ");
        } else {
            filter = [];
        }

        if (filter.length > 0) {
            //first, remove the 'found' class of all loggers
            me.visual.find(".menu-box-content li").removeClass('found');
            // Then add it to the loggers which contain a filter expression
            for (i = 0; i < filter.length; i++) {
                if (filter[i].length>0) {
                    me.visual.find(".menu-box-content li:contains('" + filter[i] + "')").addClass('found');
                }
            }
        } else {
            // If no filter was set - set all loggers as found.
            me.visual.find(".menu-box-content li").not(".found").addClass('found');
        }

        if (me.filterFav) {
            // now, handle the favorites
            me.visual.find(".menu-box-content li .fav").not(".likeIt").each(function() {
                $(this).parents(".menu-box-content li").removeClass("found");
            });
            
        } else {
            me.visual.find(".menu-box-content li").show();
        }
        //hide everything which didn't get found.
        me.visual.find(".menu-box-content li").not(".found").hide();

        //hide all menu groups with no visible menu entry
        me.visual.find('.menu-box').filter(function() {return $(this).find('.found').length===0}).hide();


        if (me.visual.find(".menu-box:visible").length === 0) {
            me.showInfo(me.resources.noEntriesExist, "", false);
        } else {
            me.showInfo("", "", false);
        }

        me.visual.find(".list").show();

        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }
};






Menu.prototype.initUserOptions = function () {
    /// <summary>
    /// This function fetches existing user options and sets the favorite icons.
    /// </summary>
    var me = this;
    var i;
    try {
       //first, load all set favorite menu entries
        me.userOptions.getUserOptions({ 'optgroupid': 'menu-favorites' }, function (result) {
            if (result !== null) {
                if (result.rows === null) { alert(me.resources.err_loadData); return false; }
                for (i = 0; i < result.rows.length; i++) {
                    if (result.rows[i].bval) {
                        me.visual.find(".fav[data-mid=" + result.rows[i].optid + "]").addClass('likeIt');
                    }
                }
            }
            //now, we load all other filter options
            me.userOptions.getUserOptions({ 'optgroupid': 'menu' }, function (result) {
                if (result !== null) {
                    if (result.rows === null) { alert(me.resources.err_loadData); return false; }
                    for (i = 0; i < result.rows.length; i++) {
                        if (result.rows[i].optid === 1 && result.rows[i].bval) {
                            me.visual.find("#divBtnFilterFav").addClass("button-toggle-active");
                            me.filterFav = result.rows[i].bval;
                        }
                    }
                }
                me.initList();
                me.filter();
                return true;
            });
            return true;
        });
        return true;
    } catch (ex) { writeError('Menu.js.initUserOptions', ex);return false; }

}


Menu.prototype.initList = function () {
    /// <summary>
    /// This function inits all click handlers for the entry list items, the favorite icons and the favorites button.<br/>
    /// It get's initiated after all user options where set!
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }
        me.visual.find(".list").fadeIn(500);
       
        me.visual.find('#divBtnFilterFav').off('click').on('click', function () {
            me.toggleBtnFilterFav($(this), "menu");
        });

        me.visual.find("#txtFilter").focus();

        me.adoptListHeight();


        return true;
    } catch (ex) { me.writeError('initList', ex); return false; }
};





Menu.prototype.toggleFavorites = function (obj) {
    /// <summary>
    /// This function adds/removes a menu entry from the favorites list. It stores the setting as user option. 
    /// </summary>
    var me = this;
    try {

        obj.toggleClass("likeIt");
        me.userOptions.setUserOptions({ 'optgroupid': 'menu-favorites', 'optid': parseInt(obj.attr("data-mid"), 10), 'bval': obj.hasClass("likeIt") }, function () { });
        me.filter();
        return true;
    } catch (ex) { me.writeError('toggleFavorites', ex); return false; }
};

